import _axios from '../../apiClient'

export function getConfigVidriera() {
    return _axios
        .get(`/ConfigGlobal/GetModoVidriera`, {
            headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        })
        .then((response) => response.data.vidriera)
        .catch((error) => {
            const data = error.response.data
            throw data
        })
}

export function getConfigFeedback() {
    return _axios
        .get(`/ConfigGlobal/GetFeedback`, {
            headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        })
        .then((response) => response.data)
        .catch((error) => {
            const data = error.response.data
            throw data
        })
}

export function updateConfigFeedback(feedbackToken) {
    return _axios
        .put(`/ConfigGlobal/UpdateFeedback`,
            { feedbackToken: feedbackToken }, 
            { 
                headers: { 'Content-Type': 'application/json;charset=UTF-8' },
            }
        )
        .then((response) => response.data)
        .catch((error) => {
            const data = error.response.data
            throw data
        })
}